import * as Yup from "yup";
import { FORM_BUILDER_FIELDS_NAME } from "../pages/FormBuilder/constant";

export const FormBuilderSchema = Yup.object().shape({
  [FORM_BUILDER_FIELDS_NAME.name]: Yup.string().required("Name is required"),
  [FORM_BUILDER_FIELDS_NAME.site]: Yup.string()
    .url("Invalid Url")
    .required("Website is required"),
});
